import { CalculatedValueAddToDate } from "../field"

export class AddToDateInputArgs {
	value: CalculatedValueAddToDate
	propName: string

	constructor (value: CalculatedValueAddToDate, propName: string) {
		this.value = value
		this.propName = propName
	}
}
